import { Component, inject, OnInit } from '@angular/core';
import { LottoFacade } from '@fgb/core';

@Component({
  selector: 'fgb-lottos-page',
  templateUrl: './lottos-page.component.html',
  styleUrls: ['./lottos-page.component.scss']
})
export class LottosPageComponent implements OnInit {
  private lottoFacade = inject(LottoFacade)

  ngOnInit() {
    this.lottoFacade.fetchLottos()
  }
}
